// TODO: move to ui package after https://github.com/myprizepicks/prizepicks-fe-applications/pull/1039
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as React from 'react';
import { CircleIcon } from 'lucide-react';
import { shadcnClassNames as cn } from '@library/component-utils/cn';

interface RadioGroupProps
  extends React.ComponentProps<typeof RadioGroupPrimitive.Root> {
  className?: string;
}

function RadioGroup({ className = '', ...props }: RadioGroupProps) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="radio-group"
      className={cn('grid gap-3', className)}
      {...props}
    />
  );
}

interface RadioGroupCardItemProps
  extends React.ComponentProps<typeof RadioGroupPrimitive.Item> {
  className?: string;
  label: string;
  description?: string | null;
}

function RadioGroupCardItem({
  className = '',
  children = null,
  label,
  description = null,
  ...props
}: RadioGroupCardItemProps) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="radio-group-item"
      className={cn(
        'data-[state=checked]:border-soClean-100 bg-soFresh-110 border-soFresh-130 data-[state=checked]:text-soClean-100 group relative flex items-center space-x-4 rounded-lg border p-4',
        className
      )}
      {...props}
    >
      <div className="border-soClean-180 group-data-[state=checked]:border-soClean-100 focus-visible:border-soClean-120 focus-visible:ring-soClean-120/50 aria-invalid:ring-status-failure/20 aria-invalid:border-status-failure text-soClean-100 shadow-xs outline-hidden relative flex aspect-square size-4 shrink-0 items-center justify-center rounded-full border transition-[color,box-shadow] focus-visible:ring disabled:cursor-not-allowed disabled:opacity-50">
        <RadioGroupPrimitive.Indicator data-slot="radio-group-indicator">
          <CircleIcon className="fill-soClean-100 absolute left-1/2 top-1/2 size-2.5 -translate-x-1/2 -translate-y-1/2" />
        </RadioGroupPrimitive.Indicator>
      </div>
      <div className="text-soClean-100 flex flex-col items-start gap-2">
        <div>{label}</div>
        {description && (
          <div className="text-soClean-180 text-left text-xs">
            {description}
          </div>
        )}
        {children}
      </div>
    </RadioGroupPrimitive.Item>
  );
}
export { RadioGroup, RadioGroupCardItem };
